import H4 from './H4'

export default H4
